import { Box, Checkbox, Column, Icon, Input, Row, Text, Tooltip } from '@amzn/meridian';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import { DestinationUrlInput } from 'features/campaign/campaign.types';
import { placeholderMapping } from 'features/traffic/campaigns/content/common-components/RefTaggedLinkEditor/link-type-and-link-type-value-utils';
import { useMemo } from 'react';
import { getLinkValueTitle } from '../utils';

type LinkValueInputProps = {
  linkType: DestinationUrlInput;
  onChange: (value: string) => void;
  value: string;
  validationError?: string;
  showDealsVariations?: boolean;
  onDealsVariationsChange?: (checked: boolean) => void;
};

export const LinkValueInput = ({
  linkType,
  onChange,
  value,
  validationError,
  showDealsVariations,
  onDealsVariationsChange,
}: LinkValueInputProps) => {
  const title = useMemo(
    () => getLinkValueTitle(linkType),
    [
      linkType,
    ],
  );

  const displayPlaceholder = placeholderMapping[linkType] || '';

  return (
    <Box>
      <Row
        alignmentVertical="bottom"
        widths={[
          'fill',
          'fit',
        ]}
      >
        <Column>
          <Input error={!!validationError} label={title} onChange={onChange} placeholder={displayPlaceholder} value={value} />
        </Column>
        {linkType === DestinationUrlInput.DEALS && onDealsVariationsChange && (
          <Column>
            <Box>
              <Row>
                <Column width="fit">
                  <Checkbox checked={showDealsVariations ?? false} onChange={onDealsVariationsChange} size="small">
                    Show variations
                  </Checkbox>
                </Column>
                <Column width="fit">
                  <Tooltip
                    position="bottom"
                    title="This setting determines whether the variations of the Deal ASIN(s) will be visible in the customer experience."
                  >
                    <Icon tokens={infoKnockoutTokens} />
                  </Tooltip>
                </Column>
              </Row>
            </Box>
          </Column>
        )}
      </Row>
      {validationError && (
        <Box aria-live="polite" spacingInset="200 none none none">
          <Text color="error" type="b100">
            {validationError}
          </Text>
        </Box>
      )}
      {linkType === DestinationUrlInput.BROWSE_NODE && (
        <Text color="secondary" type="b200">
          For custom URLs (e.g. amazon.com/kindle), use the 'Manual' link type instead of 'Browse node'
        </Text>
      )}
    </Box>
  );
};
